/**
 * Created by fijas on 5/29/17.
 */
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Search} from '../../onm/Search';
import {Project} from '../../onm/Project';
import {Observable} from 'rxjs';
import {NoteForm} from '../../projects/projects-detail/NoteForm';
import {StandardResponse} from '../../common/models/StandardResponse';
import {Reminder} from '../../projects/projects-detail/Reminder';

@Injectable()
export class OnmService {

    readonly onmProjectsUrl: string; // URL to web api
    readonly onmProjectNoteUrl: string; // URL to web api
    readonly onmProjectReminderUrl: string; // URL to web api
    readonly onmProjectFavoriteUrl: string; // URL to web api

    constructor(private http: HttpClient) {
        this.onmProjectsUrl = environment.apiBaseUrl + 'onm/projects';
        this.onmProjectNoteUrl = environment.apiBaseUrl + 'onm/project-notes';
        this.onmProjectReminderUrl = environment.apiBaseUrl + 'onm/reminders';
        this.onmProjectFavoriteUrl = environment.apiBaseUrl + 'onm/favorites';
    }

    // extraParams: deep-link filters (e.g. from AI search "View all") passed straight
    // through to the API and merged over the interactive Search model's params.
    getProjects(page: string, searchModel: Search, view: string, selectedFields?, extraParams?: Record<string, string>) {
        const expandArray: any[] = [];
        for (const i in selectedFields) {
            if (selectedFields[i].default === 0) {
                expandArray.push(selectedFields[i].value);
            }
        }
        let expandColumns = '';
        expandColumns = expandArray.join();

        const searchParameters = {...searchModel.getValuesAsParams(), ...(extraParams ?? {})};
        searchParameters.page = page;
        if (view != null) {
            searchParameters.view = view;
        }

        let params = new HttpParams();
        Object.keys(searchParameters).forEach(function(key) {
            params = params.append(key, searchParameters[key]);
        });
        return this.http.get(this.onmProjectsUrl + '?expand=' + expandColumns, {params: params, observe: 'response'});
    }

    getOilNGasProjects(page: string, searchModel: Search, view: string, selectedFields?, extraParams?: Record<string, string>) {
        const expandArray: any[] = [];
        for (const i in selectedFields) {
            if (selectedFields[i].default === 0) {
                expandArray.push(selectedFields[i].value);
            }
        }
        let expandColumns = '';
        expandColumns = expandArray.join();

        const searchParameters = {...searchModel.getValuesAsParams(), ...(extraParams ?? {})};
        searchParameters.page = page;
        if (view != null) {
            searchParameters.view = view;
        }

        let params = new HttpParams();
        Object.keys(searchParameters).forEach(function(key) {
            params = params.append(key, searchParameters[key]);
        });
        return this.http.get(this.onmProjectsUrl + '?type=1&expand=' + expandColumns, {params: params, observe: 'response'});
    }

    getOilNGasProject(id: number) {
        return this.http.get<Project>(this.onmProjectsUrl + '/' + id, {
            observe: 'response',
        });
    }

    searchProject(term: string): Observable<Project[]> {
        return this.http.get<Project[]>(this.onmProjectsUrl + '/lookup?q=' + term);
    }

    toggleFavorite(projectId: number): Observable<StandardResponse> {
        return this.http.post<StandardResponse>(this.onmProjectFavoriteUrl, {id: projectId, type: 0});
    }

    saveNote(noteForm: NoteForm): Observable<StandardResponse> {
        return this.http.post<StandardResponse>(this.onmProjectNoteUrl, noteForm);
    }

    removeNote(id: number): Observable<StandardResponse> {
        return this.http.delete<StandardResponse>(this.onmProjectNoteUrl + '/' + id.toString());
    }

    getReminders(id: number): Observable<Reminder[]> {
        const params = new HttpParams()
            .set('type', '0')
            .set('id', id.toString());

        return this.http.get<Reminder[]>(this.onmProjectReminderUrl, {params: params});
    }

    removeReminder(id: number): Observable<any> {
        return this.http.delete<any>(this.onmProjectReminderUrl + '/' + id.toString() + '?type=0');
    }

    addNewReminder(date: string, note: string, id: number): Observable<StandardResponse> {
        return this.http.post<StandardResponse>(this.onmProjectReminderUrl, {date: date, note: note, project_id: id, type: 0});
    }

    getRelatedProjects(id: number): Observable<Project[]> {
        return this.http.get<Project[]>(this.onmProjectsUrl + '/' + id + '/related');
    }
    getOnmRefurbishmentStages(){
        return this.http.get(this.onmProjectsUrl + '/get-stages');
    }
}
